import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=0a2cc26c"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a2cc26c')) {
      api.createRecord('0a2cc26c', component.options)
    } else {
      api.reload('0a2cc26c', component.options)
    }
    module.hot.accept("./ResetPassword.vue?vue&type=template&id=0a2cc26c", function () {
      api.rerender('0a2cc26c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/secure/ResetPassword.vue"
export default component.exports